<template>
  <div class="space-y-2">
    <span class="text-sm font-medium text-gray-700">{{ attributeName }}</span>
    <div class="flex flex-wrap gap-2">
      <button
        v-for="term in terms"
        :key="term.id"
        class="px-4 py-2 rounded-lg border-2 transition-colors relative"
        :class="{
          'border-orange-500 bg-orange-500 text-white': isSelected(term),
          'border-gray-300 hover:border-gray-400': !isSelected(term)
        }"
        @click="handleTermSelect(term)"
      >
        <span
          class="text-sm"
          :class="{
            'text-white': isSelected(term),
            'text-gray-700': !isSelected(term)
          }"
        >
          {{ term.name }}
        </span>
        <div
          v-if="!isTermAvailable(term)"
          class="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-white flex items-center justify-center border border-gray-200"
        >
          <Icon name="heroicons:x-mark" class="w-3 h-3 text-gray-400" />
        </div>
      </button>
    </div>
  </div>
</template>

<script setup>
const variationStore = useBuyboxVariationsStore()

const props = defineProps({
  attributeName: {
    type: String,
    required: true
  },
  terms: {
    type: Array,
    required: true,
    default: () => []
  }
})

const isSelected = (term) => {
  return variationStore.selectedTerms[props.attributeName] === term.name
}

const isTermAvailable = (term) => {
  return variationStore.isTermAvailable(props.attributeName, term.name)
}

const handleTermSelect = (term) => {
  variationStore.selectTerm(props.attributeName, term.name)
}
</script>
